import {css} from 'lit';
export const styles = css`/* stylelint-disable custom-property-empty-line-before */

:host {
  --dot-menu-trigger-width: 0;
  --dot-menu-trigger-height: var(--chat-msg-menu-trigger-height);
  --dot-menu-trigger-padding: var(--chat-msg-menu-trigger-padding);
  --dot-menu-trigger-border: var(--chat-msg-menu-trigger-border);
  --dot-menu-trigger-radius: var(--chat-msg-menu-trigger-radius);

  --dot-menu-trigger-bg: var(--chat-msg-menu-trigger-background);
  --dot-menu-trigger-bg-hover: var(--chat-msg-menu-trigger-background-hover);
  --dot-menu-trigger-bg-active: var(--chat-msg-menu-trigger-background-active);
  --dot-menu-trigger-color: var(--chat-msg-menu-trigger-color);
  --dot-menu-trigger-color-hover: var(--chat-msg-menu-trigger-color-hover);
  --dot-menu-trigger-color-active: var(--chat-msg-menu-trigger-color-active);
  --dot-menu-trigger-focus-outline-offset: -2px;

  --emoji-size-lg: 2em;
  --emoji-size-sm: 1.2em;

  --chat-msg-reply-margin-bottom: 8px;

  position: relative;
  display: flex;
  align-self: flex-start;
  max-width: var(--chat-msg-max-width);
  margin-top: var(--chat-msg-margin);
  margin-bottom: var(--chat-msg-margin);
  outline: none;
  -webkit-user-select: auto;
          user-select: auto;
  -webkit-user-select: var(--chat-msg-user-select, auto);
          user-select: var(--chat-msg-user-select, auto);
}

:host([my]) {
  --chat-msg-background: var(--chat-msg-my-background);
  --chat-msg-color: var(--chat-msg-my-color);
  --chat-msg-color-secondary: var(--chat-msg-my-color-secondary);
  --link-text: var(--chat-msg-my-link-text);
  --link-text-hover: var(--chat-msg-my-link-text-hover);
  --link-text-active: var(--chat-msg-my-link-text-active);
  --chat-msg-sender-color: var(--chat-msg-my-sender-color);
  --chat-msg-border-radius: var(--chat-msg-my-border-radius);
  --chat-msg-spacer: var(--chat-msg-my-spacer);

  --chat-msg-info-border-radius: var(--chat-msg-my-info-border-radius);
  --chat-msg-info-color: var(--chat-msg-my-info-color);
  --chat-msg-info-icon-color: var(--chat-msg-my-info-icon-color);

  --chat-msg-picture-border-radius: var(--chat-msg-my-picture-border-radius);
  --chat-msg-picture-background: var(--chat-msg-my-picture-background);

  --dot-menu-trigger-bg: var(--chat-msg-my-menu-trigger-background);
  --dot-menu-trigger-bg-hover: var(--chat-msg-my-menu-trigger-background-hover);
  --dot-menu-trigger-bg-active: var(
    --chat-msg-my-menu-trigger-background-active
  );
  --dot-menu-trigger-color: var(--chat-msg-my-menu-trigger-color);
  --dot-menu-trigger-color-hover: var(--chat-msg-my-menu-trigger-color-hover);
  --dot-menu-trigger-color-active: var(--chat-msg-my-menu-trigger-color-active);

  align-self: flex-end;
}

ef-attachment[layout='lg'] {
  width: calc(var(--chat-msg-max-width) - (var(--chat-msg-padding-unit) * 2));
  max-width: 100%;
}

ef-attachment[layout='sm'] {
  max-width: 100%;
}

.content {
  position: relative;
  min-width: 1px; /* Child overflows parent element fix */
  padding: var(--chat-msg-padding);
  border-radius: var(--chat-msg-border-radius);
  background-color: var(--chat-msg-background);
  color: var(--chat-msg-color);
  font-size: var(--chat-msg-font-size);
  transition: background-color var(--transition-timing) 0.5s;
}

.content.has-body .attachment {
      margin-bottom: 4px;
    }

.content.has-body .picture {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

.content.my .sender {
      margin-right: 24px;
    }

.content.my.has-body {
      --chat-msg-picture-border-radius: var(--chat-msg-my-border-radius);
    }

.content.error {
    --chat-msg-background: var(--chat-msg-error-background);
    --chat-msg-color: var(--chat-msg-error-color);
    --chat-msg-color-secondary: var(--chat-msg-error-color-secondary);
    --link-text: var(--chat-msg-error-link-text);
    --link-text-hover: var(--chat-msg-error-link-text-hover);
    --chat-msg-sender-color: var(--chat-msg-error-sender-color);
    --chat-msg-info-color: var(--chat-msg-error-info-color);
    --chat-msg-info-icon-color: var(--chat-msg-error-info-icon-color);
    --chat-msg-seen-info-icon-color: var(--chat-msg-error-seen-info-icon-color);
    --chat-msg-reply-background: var(--chat-msg-reply-error-background);
  }

.content.edit {
    --chat-msg-background: var(--chat-msg-edit-background);
    --chat-msg-color: var(--chat-msg-edit-color);
    --chat-msg-color-secondary: var(--chat-msg-edit-color-secondary);
    --link-text: var(--chat-msg-edit-link-text);
    --link-text-hover: var(--chat-msg-edit-link-text-hover);
    --link-text-active: var(--chat-msg-edit-link-text-active);
    --chat-msg-sender-color: var(--chat-msg-edit-sender-color);
    --chat-msg-info-color: var(--chat-msg-edit-info-color);
    --chat-msg-info-icon-color: var(--chat-msg-edit-info-icon-color);
    --chat-msg-seen-info-icon-color: var(--chat-msg-edit-seen-info-icon-color);
  }

.content.has-sender .picture,
    .content.has-sender .file {
      margin-top: 4px;
    }

.content.has-sender .picture {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

.content.has-picture:not(.has-body) {
    --chat-msg-info-padding: var(--chat-msg-info-padding-secondary);
  }

.content.has-picture:not(.has-body) .info {
      position: absolute;
      bottom: 0;
      right: 0;
    }

.content.has-file:not(.has-body) .file + .info {
      margin-top: 2px;
    }

.avatar {
  position: relative;
  margin-right: 4px;
}

ef-online-status {
  --border: transparent;
  --background: transparent;
  --border-secondary: #fff;
  --background-secondary: var(--success);
  --size: 10px;

  position: absolute;
  right: 0;
  top: 16px;
  z-index: 1;
}

.picture {
  display: block;
  margin: var(--chat-msg-picture-margin);
  background-color: var(--chat-msg-picture-background);
  border-radius: var(--chat-msg-picture-border-radius);
  overflow: hidden;
}

.picture img {
    display: block;
    min-width: 150px;
    max-height: var(--chat-msg-img-max-height);
    max-width: var(--chat-msg-img-max-width);
    margin-left: auto;
    margin-right: auto;
    object-fit: cover; /* Small portrait images are nonproportional stretched */
    cursor: zoom-in;
  }

.audio {
  min-height: 60px;
}

.audio audio {
    max-width: 100%;
  }

.video {
  width: 100%;
  padding-bottom: 56.25%;
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--chat-msg-border-radius);
  overflow: hidden;
}

.video video {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

.sender {
  position: relative;
  display: inline-block;
  color: var(--chat-msg-sender-color);
  font-size: 14px;
}

.sender span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding-right: 20px;
    overflow: hidden;
    font-weight: 600;
  }

.sender ef-icon {
    position: absolute;
    top: 1px;
    right: 0;
    font-size: 16px;
  }

.message-error {
  margin-bottom: 8px;
  color: var(--chat-msg-color-secondary);
  font-style: italic;
}

.info {
  position: relative;
  right: var(--chat-msg-info-offset-x);
  bottom: var(--chat-msg-info-offset-y);
  display: flex;
  align-items: center;
  float: right;
  margin: var(--chat-msg-info-margin);
  padding: var(--chat-msg-info-padding);
  border-radius: var(--chat-msg-info-border-radius);
  background-color: var(--chat-msg-background);
  color: var(--chat-msg-info-color);
  font-size: var(--chat-msg-info-font-size);
  transition: background-color var(--transition-timing) 0.5s;
  outline: none;
}

.info .tooltip {
    position: absolute;
    right: calc(100% + 8px);
    bottom: 50%;
    max-width: 0;
    padding: 8px;
    background-color: var(--contrast-light);
    border-radius: var(--chat-msg-border-radius);
    color: var(--dark-text);
    opacity: 0;
    transition: opacity var(--transition-timing) var(--transition-duration);
    white-space: nowrap;
    overflow: hidden;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.2);
    visibility: hidden;
  }

.info.focus-visible {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: var(--link-focus-outline-offset);
  }

.info:focus-visible {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: var(--link-focus-outline-offset);
  }

.info[focus-within] {
    z-index: 10;
  }

.info[focus-within] .tooltip {
      max-width: none;
      visibility: visible;
      opacity: 0.9;
    }

.info:focus-within {
    z-index: 10;
  }

.info[focus-within] .tooltip {
      max-width: none;
      visibility: visible;
      opacity: 0.9;
    }

.info:focus-within .tooltip {
      max-width: none;
      visibility: visible;
      opacity: 0.9;
    }

.info .status-indicator {
    display: inline-block;
    min-width: 3ex;
  }

.info ef-icon {
    color: var(--chat-msg-info-icon-color);
    font-size: var(--chat-msg-info-icon-size);
  }

.info ef-icon + ef-icon {
    margin-left: -12px;
  }

.info .created-at {
    margin-right: 4px;
    cursor: default;
  }

.info .seen {
    --chat-msg-info-icon-color: var(--chat-msg-seen-info-icon-color);
  }

.message-edited {
  margin-left: 4px;
  color: var(--chat-msg-color-secondary);
  font-size: 0.85em;
  text-transform: lowercase;
}

.message-deleted {
  display: flex;
  align-items: center;
}

.message-deleted ef-icon {
    margin-right: 8px;
    font-size: 20px;
  }

.message-deleted span {
    color: var(--chat-msg-color-secondary);
    font-size: 0.9em;
    font-style: italic;
  }

.spacer {
  display: inline-block;
  width: var(--chat-msg-spacer);
}

ef-truncate {
  --btn-align: left;
  --mask-color: var(--chat-msg-background);
  --btn-divider: none;

  display: block;
  margin-bottom: 0;
}

ef-truncate .truncate-content {
    word-break: break-word;
    white-space: pre-wrap;
  }

ef-truncate a {
    -webkit-text-decoration: var(--chat-msg-link-decoration);
            text-decoration: var(--chat-msg-link-decoration);
  }

ef-truncate .emoji-lg {
    font-size: var(--emoji-size-lg);
  }

ef-truncate .emoji-sm {
    font-size: var(--emoji-size-sm);
  }

.actions {
  text-align: center;
  white-space: nowrap;
  clear: both;
}

.actions button {
    width: 40px;
    height: 40px;
    margin-top: 16px;
    padding: 0;
    background-color: rgba(255, 255, 255, 0.6);
    border: 1px solid var(--border-light);
    border-radius: 50%;
    font-size: 24px;
    color: var(--text-secondary);
  }

@media (hover: hover) {
      .actions button:hover {
        background-color: rgba(255, 255, 255, 1);
      }
    }

.actions button:active {
      background-color: rgba(255, 255, 255, 0.6);
    }

.actions button:first-child {
      margin-right: 8px;
    }

ef-chat-message-menu {
  position: absolute;
  top: var(--chat-msg-menu-top);
  right: var(--chat-msg-menu-right);
  z-index: 50;
}

progress {
  -webkit-appearance: none;
          appearance: none;
  position: absolute;
  width: 80%;
  background: rgba(255, 255, 255, 0.8);
  padding: 4px;
  border-radius: 8px;
  height: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* FF */

progress::-moz-progress-bar {
  background-color: var(--primary) !important;
}

progress::-moz-progress-bar {
  border-radius: 10px;
}

/* Chrome */

progress::-webkit-progress-bar {
  background-color: transparent;
}

/* This needs to be written twice to work */

progress::-webkit-progress-value {
  background-color: var(--primary) !important;
}

progress::-webkit-progress-value {
  border-radius: 10px;
}

:host(.focus-visible) {
  outline: none;
}

:host(.focus-visible) .content {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: var(--link-focus-outline-offset);
  }

:host(:focus-visible) {
  outline: none;
}

:host(.focus-visible) .content {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: var(--link-focus-outline-offset);
  }

:host(:focus-visible) .content {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: var(--link-focus-outline-offset);
  }

@media (hover: hover) {
  :host(:hover) {
    --dot-menu-trigger-width: var(--chat-msg-menu-trigger-width);
  }
}

@media (max-width: 767px) {

:host(:active) {
    --chat-msg-background: var(--chat-msg-background-active)
}

    :host(:active) .content,
    :host(:active) .info {
      transition: none;
    }
  }

:host([menuOpen]) {
  --dot-menu-trigger-width: var(--chat-msg-menu-trigger-width);
}

@media (max-width: 767px) {

:host([my]:active) {
    --chat-msg-background: var(--chat-msg-my-background-active)
}

    :host([my]:active) .content,
    :host([my]:active) .info {
      transition: none;
    }
  }

[data-mention-id]::before {
  content: '@';
}
`;
export default styles;
